export default "__VITE_ASSET__X6iFTJ1U__"